// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"6586":"product-metadata","7294":"app-messages-en_US"}[chunkId] + "." + {"6586":"e39355d7","7294":"991bf1ce"}[chunkId] + ".chunk.js";
};